import { createSlice } from "@reduxjs/toolkit";

const initialnotificationState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  notificationForEdit: undefined,
  lastError: null,
  // ! PROGRAM, DONOR, DONATION COUNT
  donorCount: 0,
  donationCount: 0,
  programCount: 0,
  // ? LIBRARY FILES
  notificationFiles: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminNotificationSlice = createSlice({
  name: "notification",
  initialState: initialnotificationState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getnotificationById
    notificationFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.notificationForEdit = action.payload.notificationForEdit;
      state.donorCount = action.payload.donorCount;
      state.donationCount = action.payload.donationCount;
      state.programCount = action.payload.programCount;
    },
    // findnotification
    notificationsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    notificationReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
    notificationFiles: (state, action) => {
      state.notificationFiles = action.payload.items;
      state.totalCount = action.payload.total_items;
      state.listLoading = false;
      state.actionsLoading = false;
    },
    notificationFilesFetched: (state, action) => {
      state.notificationFiles = action.payload.items;
      state.listLoading = false;
      state.actionsLoading = false;
    }
  }
});
